/* eslint-disable import/prefer-default-export */
import backgroundMedium from './images/backgroundMedium.jpg';
import backgroundBig from './images/backgroundBig.png';

export const images = {
  backgroundMedium,
  backgroundBig,
};
